import { render, staticRenderFns } from "./AmountBreakdown.vue?vue&type=template&id=75cb39e2"
import script from "./AmountBreakdown.vue?vue&type=script&lang=js"
export * from "./AmountBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports